
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import HeroSection from './components/HeroSlider';
import Header from './components/Header';
import AboutSection from './components/AboutSection';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import ContactInfo from './pages/ContactInfo';
import Enquiry from './pages/Enquiry';
import Career from './pages/Career';
import Gallery from './pages/Gallery';
import Booking from './pages/Booking';
import Network from './pages/Network';
import Packages from './pages/Packages';
import Ourfleets from './pages/Ourfleets';
import Service from './pages/Service';
import Footer from './components/Footer';
import Nagarsoltoshirdicab from './pages/Nagarsol to Shirdi Cab';
import ScrollToTop from './components/ScrollToTop';
import Shirdicabservice from './pages/Shirdi Cab Service';
import Shirditoshanishignapur from './pages/Shirdi to Shani Shingnapur Cab';
import Shirditogrishneshwarcab from './pages/Shirdi to Grishneshwar Cab';
import Shirditomanmadcab from './pages/Shirdi to Manmad Cab';
import Shirditolonavalacab from './pages/Shirdi to Lonavala Cab';
import Shirditomahabaleshawarcab from './pages/Shirdi to Mahabaleshwar Cab';
import Shirditoashtavinayakdarshan from './pages/Shirdi to Ashtavinayak Darshan Package';
import Shirditosaptashrungicab from './pages/Shirdi to Saptashrungi Cab';
import Shirditourpackage from './pages/Shirdi Tour Package';
import Besttaxiserviceinshirdi from './pages/Best Taxi Service in Shirdi';
import Shirdiairportcabservice from './pages/Shirdi Airport Cab Service';
import Onlinecabbookingshirdi from './pages/Online Cab Booking Shirdi';
import Besttravelagencyinshirdi from './pages/Best Travel Agency in Shirdi';
import Shirditomumaiairportcab from './pages/Shirdi to Mumbai Airport Cab';
import Koregaontoshirdicab from './pages/Kopargaon to Shirdi Cab';
import Innovaonrentinshirdi from './pages/Innova on Rent in Shirdi';
import Shirdisightseeingcab from './pages/Shirdi Sisghtseeing Cab';
import Shirdidarshantaxi from './pages/Shirdi Darshan Taxi';
import Busonhireinshirdi from './pages/Bus on Hire in Shirdi';
import Bestsedancabinshirdi from './pages/Best Sedan Cab in Shirdi';
import Eritigacarhireinshirdi from './pages/Ertiga Car Hire in Shirdi';
import Innovacrystaonrentinshirdi from './pages/Innova Crysta on Rent in Shirdi';
import Minibusonrentinshirdi from './pages/Mini Bus on Rent in Shirdi';
import Tempotravellerhireinshirdi from './pages/Tempo Traveller Hire in Shirdi';
import Shirditohyderabadcab from './pages/Shirdi to Hyderabad Cab';
import Shirditoujjaincab from './pages/Shirdi to Ujjain Cab';
import Shirditosaptaracab from './pages/Shirdi to Saputara Cab';
import Shirditoaurangabadairport from './pages/Shirdi to Aurangabad Airport Cab';
import Multiseaterbusonrent from './pages/32 35 40 45 50 Seater Bus on Rent in Shirdi';
import Shirditopandharpurcab from './pages/Shirdi to Pandharpur Cab';
import Ozarairporttoshirdicab from './pages/Ozar Airport to Shirdi Cab';
import Nashikrailwaystation from './pages/Nashik Railway Station to Shirdi Cab';
import Shirditobhandadharacab from './pages/Shirdi to Bhandardara Cab On Rent';
import Nashikairporttoshirdicab from './pages/Nashik Airport to Shirdi Cab';
import Shirditolgatpuricab from './pages/Shirdi to Igatpuri Cab';
import Shirditogoacab from './pages/Shirdi to Goa Cab';
import Corporatecabserviceinshirdi from './pages/Corporate Cab Service in Shirdi';
import Shirditomumbaidarshantaxi from './pages/Shirdi to Mumbai Darshan Taxi';
import Shirditonagpurtaxi from './pages/Shirdi to Nagpur Taxi';
import Bestcabserviceinshirdi from './pages/Best Cab Service in Shirdi';
import Outstationcabserviceinshirdi from './pages/Outstation Cab Service in Shirdi';
import Manmadtoshirditaxi from './pages/Manmad to Shirdi Taxi';
import Shirditotrimbkeshwarcab from './pages/Shirdi to Trimbakeshwar Cab';
import Shirditobhimashankarcab from './pages/Shirdi to Bhimashankar Cab';
import Shirditonashikcabs from './pages/Shirdi to Nasik Cabs';
import Nashiktoshirdicabs from './pages/Nashik to Shirdi Cab';
import Shirditoaurangabadtaxi from './pages/Shirdi to Aurangabad Taxi';
import Shirditoshanishignapurtaxi from './pages/Shirdi to Shani Shingnapur Taxi';
import Shirditomanmadtaxifare from './pages/Shirdi to Manmad Taxi Fare';
import Solapurtoshirdicab from './pages/Solapur to Shirdi Cab';
import Daundtoshirdicab from './pages/Daund to Shirdi Cabs';
import ShirdiToGoaCabService from './pages/Shirdi to Goa Cab Service';
import Shirditopunecab from './pages/Shirdi to Pune Cabs';
import Shirditomumbaicab from './pages/Shirdi to Mumbai Cab';
import Mumbaitoshirdicab from './pages/Mumbai to Shirdi Cab';
import Mumbaiairporttoshirdicab from './pages/Mumbai Airport to Shirdi Cab';
import Puneairporttoshirdicab from './pages/Pune Airport to Shirdi Cab';
import Punetoshirdicabbooking from './pages/Pune to Shirdi Cab Booking';
import Shirdiairporttonashikcab from './pages/Shirdi Airport to Nashik Cab';
import Shirditoajantaelloracavespackage from './pages/Shirdi to Ajanta Ellora Caves Package';
import Shirditofivejyotilingapackage from './pages/Shirdi to 5 Jyotirlinga Package';
import ShirdiAirportCabs from './pages/Shirdi Airport Cabs';
import MumbaiToShirdiTourPackage from './pages/Mumbai to Shirdi Tour Package';
import ShirdiCarRentals from './pages/Shirdi Car Rentals';
import Shirditoindorecabs from './pages/Shirdi to Indore Cabs';
import Weddingcarrentalshirdi from './pages/Wedding Car Rental Shirdi';
import NahikAirportToShirdiTaxi from './pages/Nasik Airport to Shirdi Taxi';
import Kalyantoshirdicarrental from './pages/Kalyan to Shirdi Car Rental';
import ShirditovetulCarRentals from './pages/Shirdi to Verul Car Rentals';
import ShirdiToKonkanDarshanCab from './pages/Shirdi to Konkan Darshan Cab';
import Bushireforweddinginshirdi from './pages/Bus Hire For Wedding in Shirdi';
import Cabbookinginshirdi from './pages/Cab Booking in Shirdi';
import ShirditaxiBookingOnline from './pages/Shirdi Taxi Booking Online';
import Shirdicabbookingpackages from './pages/Shirdi Cab Packages';
import Shirditooutstationcabbooking from './pages/Shirdi to Outstation Cabs Booking';
import Travelagentsinshirdi from './pages/Travel Agents in Shirdi';
import CorporateCabServicesInShirdi from './pages/Corporate Cab Services in Shirdi';
import Cabsforevetsinshirdi from './pages/Cabs for Events in Shirdi';
import Cabserviceinshirdimidc from './pages/Cab Service in Shirdi MIDC';
import Monthlycabservicesshirdi from './pages/Monthly Cab Service Shirdi';
import Sainagarashirditoshirdidcab from './pages/Sainagar Shirdi to Shirdi Cabs';
import Nashikroadstationtoshirdicab from './pages/Nashik Road Station to Shirdi Cab';
import Swiftdzireonrentinshirdi from './pages/Swift Dzire On Rent in Shirdi';
import InnovacrystaCabOnRentShirdi from './pages/Innova Crysta Cab on Rent Shirdi';
import ErtigaOnRentInShirdi from './pages/Ertiga On Rent in Shirdi';
import InnovaCabBookingInShirdi from './pages/Innova Cab Booking in Shirdi';
import Etioncabserviceinshirdi from './pages/Etios Cab Service in Shirdi';
import Kiacarenceonrentinshirdi from './pages/Kia Carens on Rent in Shirdi';
import TempoTraveller14SeaterRentInShirdi from './pages/Tempo Traveller 14 Seater Rent in Shirdi';
import Tempotraveller17SeaterOnRentShirdi from './pages/Tempo Traveller 17 Seater on Rent Shirdi';
import Twofiveseaterbusonrentinshirdi from './pages/25 Seater Bus on Rent in Shirdi';
import Thirtytwoseaterbusonrentinshirdi from './pages/32 Seater Bus on Rent in Shirdi';
import ThirtyfiveSeaterBusOnRentInShirdi from './pages/35 Seater Bus on Rent in Shirdi';
import Fourseaterbusonrentinshirdi from './pages/45 Seater Bus on Rent in Shirdi';
import Fiveseaterbusonrentinshirdi from './pages/50 Seater Bus on Rent in Shirdi';
import Taxibookinginshirdi from './pages/Taxi Booking in Shirdi';
import Navimumbaitoshirdicab from './pages/Navi Mumbai to Shirdi Cab';
import Thanetoshirdicab from './pages/Thane to Shirdi Cab';
import Shirditopuneairportcab from './pages/Shirdi to Pune Airport Cab';
import Shirditomumbaiairpoorttaxi from './pages/Shirdi to Mumbai Airport Taxi';
import Shirdilocalsightseeingcab from './pages/Shirdi Local Sightseeing Cabs';
import Onewaycabshirdi from './pages/One Way Cab Shirdi';
import Shirditoshegaoncabs from './pages/Shirdi to Shegaon Cab';
import AurangabadAirportToShirdiCab from './pages/Aurangabad Airport to Shirdi Cab';
import Shirdiroundtripcabbooking from './pages/Shirdi Round Trip Cab Booking';
import Shirditooootymysorecabpackage from './pages/Shirdi to Ooty Mysore Cab Package';
import Shirditogujratcab from './pages/Shirdi to Gujarat Cab';
import ShirdiToAllIndiaExplorerCabService from './pages/Shirdi to All India Explorer Cab Service';
import UrbaniaOnRentInShirdi from './pages/Urbania on Rent in Shirdi';
import UrbaniaOnRentAtShirdiAirport from './pages/Urbania on Rent at Shirdi Airport';
import OutstationUrbaniaFromShirdi from './pages/Outstation Urbania from Shirdi';
import Oneseaterurbaniaonrentinshirdi from './pages/17 Seater Urbania on Rent in Shirdi';
import Onefoururbaniaonrentinshirdi from './pages/14 Seater Urbania On Rent in Shirdi';
import LuxuryUrbaniaOnRentInShirdi from './pages/Luxury Urbania On Rent in Shirdi';
import UrbaniaonrentinAhilyanagar from './pages/Urbania On Rent in Ahilyanagar';
import Urbaniaonrentinmanmad from './pages/Urbania on Rent in Manmad';
import UrbaniaOnRentInNashik from './pages/Urbania On Rent in Nashik';
import UrbaniaOnRentInShrirampur from './pages/Urbania On Rent in Shrirampur';
import UrbaniaHireInShrirdi from './pages/Urbania Hire in Shirdi';
import Onesevanseatertempotarvelleronrentinshirdi from './pages/17 Seater Tempo Traveller On Rent in Shirdi';
import ContactButtons from './components/ContactButtons';

function App() {
  return (
    <Router>
      <ContactButtons />
      <ScrollToTop />
<Header />
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutSection />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<ContactInfo />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/career" element={<Career />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/our-network" element={<Network />} />
        <Route path="/services" element={<Service />} />
        <Route path="/Nagarsol-to-Shirdi-Cab" element={<Nagarsoltoshirdicab />} />


<Route path="/Shirdi-Cab-Service" element={<Shirdicabservice />} />
<Route path="/Shirdi-to-Shani-Shingnapur-Cab" element={<Shirditoshanishignapur />} />
<Route path="/Shirdi-to-Grishneshwar-Cab" element={<Shirditogrishneshwarcab />} />
<Route path="/Shirdi-to-Manmad-Cab" element={<Shirditomanmadcab />} />
<Route path="/Shirdi-to-Lonavala-Cab" element={<Shirditolonavalacab />} />
<Route path="/Shirdi-to-Mahabaleshwar-Cab" element={<Shirditomahabaleshawarcab />} />
<Route path="/Shirdi-to-Ashtavinayak-Darshan-Package" element={<Shirditoashtavinayakdarshan />} />
<Route path="/Shirdi-to-Saptashrungi-Cab" element={<Shirditosaptashrungicab />} />
<Route path="/Shirdi-Tour-Package" element={<Shirditourpackage />} />
<Route path="/Best-Taxi-Service-in-Shirdi" element={<Besttaxiserviceinshirdi />} />
<Route path="/Shirdi-Airport-Cab-Service" element={<Shirdiairportcabservice />} />
<Route path="/Online-Cab-Booking-Shirdi" element={<Onlinecabbookingshirdi />} />
<Route path="/Best-Travel-Agency-in-Shirdi" element={<Besttravelagencyinshirdi />} />
<Route path="/Shirdi-to-Mumbai-Airport-Cab" element={<Shirditomumaiairportcab />} />
<Route path="/Kopargaon-to-Shirdi-Cab" element={<Koregaontoshirdicab />} />
<Route path="/Innova-on-Rent-in-Shirdi" element={<Innovaonrentinshirdi />} />
<Route path="/Shirdi-Sightseeing-Cab" element={<Shirdisightseeingcab />} />
<Route path="/Shirdi-Darshan-Taxi" element={<Shirdidarshantaxi />} />
<Route path="/Bus-on-Hire-in-Shirdi" element={<Busonhireinshirdi />} />
<Route path="/Best-Sedan-Cab-in-Shirdi" element={<Bestsedancabinshirdi />} />
<Route path="/Ertiga-Car-Hire-in-Shirdi" element={<Eritigacarhireinshirdi />} />
<Route path="/Innova-Crysta-on-Rent-in-Shirdi" element={<Innovacrystaonrentinshirdi />} />
<Route path="/Mini-Bus-on-Rent-in-Shirdi" element={<Minibusonrentinshirdi />} />
<Route path="/Tempo-Traveller-Hire-in-Shirdi" element={<Tempotravellerhireinshirdi />} />
<Route path="/Shirdi-to-Hyderabad-Cab" element={<Shirditohyderabadcab />} />
<Route path="/Shirdi-to-Ujjain-Cab" element={<Shirditoujjaincab />} />
<Route path="/Shirdi-to-Saputara-Cab" element={<Shirditosaptaracab />} />
<Route path="/Shirdi-to-Aurangabad-Airport-Cab" element={<Shirditoaurangabadairport />} />
<Route path="/32-35-40-45-50-Seater-Bus-on-Rent-in-Shirdi" element={<Multiseaterbusonrent />} />
<Route path="/Shirdi-to-Pandharpur-Cab" element={<Shirditopandharpurcab />} />
<Route path="/Ozar-Airport-to-Shirdi-Cab" element={<Ozarairporttoshirdicab />} />
<Route path="/Nashik-Railway-Station-to-Shirdi-Cab" element={<Nashikrailwaystation />} />
<Route path="/Shirdi-to-Bhandardara-Cab-On-Rent" element={<Shirditobhandadharacab />} />
<Route path="/Nashik-Airport-to-Shirdi-Cab" element={<Nashikairporttoshirdicab />} />
<Route path="/Shirdi-to-Igatpuri-Cab" element={<Shirditolgatpuricab />} />
<Route path="/Shirdi-to-Goa-Cab" element={<Shirditogoacab />} />
<Route path="/Corporate-Cab-Service-in-Shirdi" element={<Corporatecabserviceinshirdi />} />
<Route path="/Shirdi-to-Mumbai-Darshan-Taxi" element={<Shirditomumbaidarshantaxi />} />
<Route path="/Shirdi-to-Nagpur-Taxi" element={<Shirditonagpurtaxi />} />
<Route path="/Best-Cab-Service-in-Shirdi" element={<Bestcabserviceinshirdi />} />
<Route path="/Outstation-Cab-Service-in-Shirdi" element={<Outstationcabserviceinshirdi />} />
<Route path="/Manmad-to-Shirdi-Taxi" element={<Manmadtoshirditaxi />} />
<Route path="/Shirdi-to-Trimbakeshwar-Cab" element={<Shirditotrimbkeshwarcab />} />
<Route path="/Shirdi-to-Bhimashankar-Cab" element={<Shirditobhimashankarcab />} />


<Route path="/Shirdi-to-Nasik-Cabs" element={<Shirditonashikcabs />} />
<Route path="/Nashik-to-Shirdi-Cab" element={<Nashiktoshirdicabs />} />
<Route path="/Shirdi-to-Aurangabad-Taxi" element={<Shirditoaurangabadtaxi />} />
<Route path="/Shirdi-to-Shani-Shingnapur-Taxi" element={<Shirditoshanishignapurtaxi />} />
<Route path="/Shirdi-to-Manmad-Taxi-Fare" element={<Shirditomanmadtaxifare />} />
<Route path="/Solapur-to-Shirdi-Cab" element={<Solapurtoshirdicab />} />
<Route path="/Daund-to-Shirdi-Cabs" element={<Daundtoshirdicab />} />
<Route path="/Shirdi-to-Goa-Cab-Service" element={<ShirdiToGoaCabService />} />
<Route path="/Shirdi-to-Pune-Cabs" element={<Shirditopunecab />} />
<Route path="/Shirdi-to-Mumbai-Cab" element={<Shirditomumbaicab />} />
<Route path="/Mumbai-to-Shirdi-Cab" element={<Mumbaitoshirdicab />} />
<Route path="/Mumbai-Airport-to-Shirdi-Cab" element={<Mumbaiairporttoshirdicab />} />
<Route path="/Pune-Airport-to-Shirdi-Cab" element={<Puneairporttoshirdicab />} />
<Route path="/Pune-to-Shirdi-Cab-Booking" element={<Punetoshirdicabbooking />} />
<Route path="/Shirdi-Airport-to-Nashik-Cab" element={<Shirdiairporttonashikcab />} />
<Route path="/Shirdi-to-Ajanta-Ellora-Caves-Package" element={<Shirditoajantaelloracavespackage />} />
<Route path="/Shirdi-to-5-Jyotirlinga-Package" element={<Shirditofivejyotilingapackage />} />
<Route path="/Shirdi-Airport-Cabs" element={<ShirdiAirportCabs />} />
<Route path="/Mumbai-to-Shirdi-Tour-Package" element={<MumbaiToShirdiTourPackage />} />
<Route path="/Shirdi-Car-Rentals" element={<ShirdiCarRentals />} />
<Route path="/Shirdi-to-Indore-Cabs" element={<Shirditoindorecabs />} />
<Route path="/Wedding-Car-Rental-Shirdi" element={<Weddingcarrentalshirdi />} />
<Route path="/Nasik-Airport-to-Shirdi-Taxi" element={<NahikAirportToShirdiTaxi />} />
<Route path="/Kalyan-to-Shirdi-Car-Rental" element={<Kalyantoshirdicarrental />} />
<Route path="/Shirdi-to-Verul-Car-Rentals" element={<ShirditovetulCarRentals />} />
<Route path="/Shirdi-to-Konkan-Darshan-Cab" element={<ShirdiToKonkanDarshanCab />} />
<Route path="/Bus-Hire-for-Wedding-in-Shirdi" element={<Bushireforweddinginshirdi />} />
<Route path="/Cab-Booking-in-Shirdi" element={<Cabbookinginshirdi />} />
<Route path="/Shirdi-Taxi-Booking-Online" element={<ShirditaxiBookingOnline />} />
<Route path="/Shirdi-Cab-Packages" element={<Shirdicabbookingpackages />} />
<Route path="/Shirdi-to-Outstation-Cabs-Booking" element={<Shirditooutstationcabbooking />} />
<Route path="/Travel-Agents-in-Shirdi" element={<Travelagentsinshirdi />} />
<Route path="/Corporate-Cab-Services-in-Shirdi" element={<CorporateCabServicesInShirdi />} />
<Route path="/Cabs-for-Events-in-Shirdi" element={<Cabsforevetsinshirdi />} />
<Route path="/Cab-Service-in-Shirdi-MIDC" element={<Cabserviceinshirdimidc />} />
<Route path="/Monthly-Cab-Service-Shirdi" element={<Monthlycabservicesshirdi />} />
<Route path="/Sainagar-Shirdi-to-Shirdi-Cabs" element={<Sainagarashirditoshirdidcab />} />


<Route path="/Nashik-Road-Station-to-Shirdi-Cab" element={<Nashikroadstationtoshirdicab />} />
<Route path="/Swift-Dzire-On-Rent-in-Shirdi" element={<Swiftdzireonrentinshirdi />} />
<Route path="/Ertiga-On-Rent-in-Shirdi" element={<ErtigaOnRentInShirdi />} />
<Route path="/Innova-Crysta-Cab-on-Rent-Shirdi" element={<Innovacrystaonrentinshirdi  />} />
<Route path="/Innova-Cab-Booking-in-Shirdi" element={<InnovaCabBookingInShirdi />} />
<Route path="/Etios-Cab-Service-in-Shirdi" element={<Etioncabserviceinshirdi />} />
<Route path="/Kia-Carens-on-Rent-in-Shirdi" element={<Kiacarenceonrentinshirdi />} />
<Route path="/Tempo-Traveller-14-Seater-Rent-in-Shirdi" element={<TempoTraveller14SeaterRentInShirdi />} />
<Route path="/Tempo-Traveller-17-Seater-on-Rent-Shirdi" element={<Tempotraveller17SeaterOnRentShirdi />} />
<Route path="/25-Seater-Bus-on-Rent-in-Shirdi" element={<Twofiveseaterbusonrentinshirdi />} />
<Route path="/32-Seater-Bus-on-Rent-in-Shirdi" element={<Thirtytwoseaterbusonrentinshirdi />} />
<Route path="/35-Seater-Bus-on-Rent-in-Shirdi" element={<ThirtyfiveSeaterBusOnRentInShirdi />} />
<Route path="/45-Seater-Bus-on-Rent-in-Shirdi" element={<Fourseaterbusonrentinshirdi />} />
<Route path="/50-Seater-Bus-on-Rent-in-Shirdi" element={<Fiveseaterbusonrentinshirdi />} />
<Route path="/Taxi-Booking-in-Shirdi" element={<Taxibookinginshirdi />} />
<Route path="/Navi-Mumbai-to-Shirdi-Cab" element={<Navimumbaitoshirdicab />} />
<Route path="/Thane-to-Shirdi-Cab" element={<Thanetoshirdicab />} />
<Route path="/Shirdi-to-Pune-Airport-Cab" element={<Shirditopuneairportcab />} />
<Route path="/Shirdi-to-Mumbai-Airport-Taxi" element={<Shirditomumbaiairpoorttaxi />} />
<Route path="/Shirdi-Local-Sightseeing-Cabs" element={<Shirdilocalsightseeingcab />} />
<Route path="/One-Way-Cab-Shirdi" element={<Onewaycabshirdi />} />
<Route path="/Shirdi-to-Shegaon-Cab" element={<Shirditoshegaoncabs />} />
<Route path="/Aurangabad-Airport-to-Shirdi-Cab" element={<AurangabadAirportToShirdiCab />} />
<Route path="/Shirdi-Round-Trip-Cab-Booking" element={<Shirdiroundtripcabbooking />} />
<Route path="/Shirdi-to-Ooty-Mysore-Cab-Package" element={<Shirditooootymysorecabpackage />} />
<Route path="/Shirdi-to-Gujarat-Cab" element={<Shirditogujratcab />} />
<Route path="/Shirdi-to-All-India-Explorer-Cab-Service" element={<ShirdiToAllIndiaExplorerCabService />} />
<Route path="/Urbania-on-Rent-in-Shirdi" element={<UrbaniaOnRentInShirdi />} />
<Route path="/Urbania-on-Rent-at-Shirdi-Airport" element={<UrbaniaOnRentAtShirdiAirport />} />
<Route path="/Outstation-Urbania-from-Shirdi" element={<OutstationUrbaniaFromShirdi />} />
<Route path="/17-Seater-Urbania-on-Rent-in-Shirdi" element={<Oneseaterurbaniaonrentinshirdi />} />
<Route path="/14-Seater-Urbania-On-Rent-in-Shirdi" element={<Onefoururbaniaonrentinshirdi />} />
<Route path="/Luxury-Urbania-On-Rent-in-Shirdi" element={<LuxuryUrbaniaOnRentInShirdi />} />
<Route path="/Urbania-On-Rent-in-Ahilyanagar" element={<UrbaniaonrentinAhilyanagar />} />
<Route path="/Urbania-on-Rent-in-Manmad" element={<Urbaniaonrentinmanmad />} />
<Route path="/Urbania-On-Rent-in-Nashik" element={<UrbaniaOnRentInNashik />} />
<Route path="/Urbania-On-Rent-in-Shrirampur" element={<UrbaniaOnRentInShrirampur />} />
<Route path="/Urbania-Hire-in-Shirdi" element={<UrbaniaHireInShrirdi />} />
<Route path="/17-Seater-Tempo-Traveller-On-Rent-in-Shirdi" element={<Onesevanseatertempotarvelleronrentinshirdi />} />

      </Routes>



      <Footer />
    </Router>
  );
}

export default App;
